<template>
  <div class="index2">
    <div class="banner2">
      <img src="../assets/imgs/num.png" alt="">
    </div>
    <el-table
      :data="olympicRankList"
      stripe>
      <el-table-column
        prop="rank"
        label=""
        width="15%">
      </el-table-column>
      <el-table-column
        prop="delegationCn"
        label=""
        width="35%">
      </el-table-column>
      <el-table-column
        prop="goldMedal"
        label=""
        width="11%"
      >
      </el-table-column>
      <el-table-column
        prop="silverMedal"
        label=""
        width="11%">
      </el-table-column>
      <el-table-column
        prop="bronzeMedal"
        label=""
        width="11%">
      </el-table-column>
      <el-table-column
        prop="total"
        label=""
        width="18%">
      </el-table-column>
    </el-table>

    <div style="position: absolute;bottom: 0rem;color:#000;text-align: center;width: 100%;background: #fff;height:0.5rem"><router-link :to="{ name: 'medal'}" style="color: #000;font-size: 0.28rem">查看更多</router-link></div>
  </div>

</template>

<script>
import axios from 'axios'
export default {
  name: "medal",
data() {
  return {
  olympicRankList: [],
  timeCn:''
  }
},
  created() {
    axios.get('https://xhnewsapi.xinhuaxmt.com/userAction/olympic/2024_PARIS_OLYMPICS')
      .then(response=>{
        console.log(response.data.result.olympicRankList)
        if(response.data.code==1000){
          this.olympicRankList = response.data.result.olympicRankList.slice(0, 5);
          this.timeCn=response.data.result.timeCn;
        }else {
          this.$notify({
            title:'网络异常，请稍后重试',
            type: 'error'
          });
        }

      })
      .catch(error=>{

// this.$notify({
//   title:'网络异常，请稍后重试',
//   type: 'error'
// });
      })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.index2{
  position: relative;
  background: #fff;
  border-radius: 0.1rem;
}
.banner2 img{
  width: 100%;
}
.index2 .el-table__body{
  width: 100% !important;
}
.index2 .el-table__header-wrapper{
  display: none;
}
.index2 .el-table .cell{
  text-align: center;
  font-size: 0.28rem;
}
.index2 .el-table__row td:nth-of-type(1) .cell{
  font-style: italic;
}
.index2 .el-table__row td:nth-of-type(3) .cell{
  text-align: center;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.index2 .el-table__row:nth-of-type(1) td:nth-of-type(1) .cell{
  color: #c37c01;
  border-radius: 0.3rem;
  width: 0.4rem;
  height: 0.4rem;
  line-height: 0.4rem;
  text-align: center;
  background: #f3e5cc;
  padding: 0 0.1rem;
  margin: 0 auto;
}
.index2 .el-table__row:nth-of-type(2) td:nth-of-type(1) .cell{
  color: #747474;
  border-radius: 0.3rem;
  width: 0.4rem;
  height: 0.4rem;
  line-height: 0.4rem;
  text-align: center;
  background: #dedede;
  padding: 0 0.1rem;
  margin: 0 auto;
}
.index2 .el-table th, .el-table tr{
  height: 0.8rem;
}
.index2 .el-table__row:nth-of-type(3) td:nth-of-type(1) .cell{
  color: #bd7a3c;
  border-radius: 0.3rem;
  width: 0.4rem;
  height: 0.4rem;
  line-height: 0.4rem;
  text-align: center;
  background: #f2e4d8;
  padding: 0 0.1rem;
  margin: 0 auto;
}
.index2 .el-table__empty-text {
  line-height: 60px;
  width: 50%;
  color: #909399;
  position: absolute;
  left: 50%;
  margin-left: -25%;
}
.index2 .el-table .cell{
  line-height: 0.5rem;
}
.index2 .el-table {
  position: absolute;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: 100%;
  max-width: 7.5rem;
  font-size: 14px;
  color: #606266;
}
</style>




// WEBPACK FOOTER //
// src/components/medal.vue